import React from 'react';
import { Check, X, ArrowRight } from 'lucide-react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function BeforeAfterSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <h2 className="text-4xl md:text-5xl font-black text-center text-gray-900 mb-12 font-['Oswald'] uppercase" data-id="element-3">
          Antes vs Después
        </h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-0" data-id="element-4">
          {/* Before */}
          <div className="bg-red-50 p-8 md:p-12 rounded-l-xl border border-red-100" data-id="element-5">
            <h3 className="text-2xl font-bold text-red-700 mb-8 text-center uppercase" data-id="element-6">
              Antes del Pack
            </h3>
            <ul className="space-y-6" data-id="element-7">
              {['Improvisación constante', 'Cansancio mental', 'Clases apuradas', 'Trabajo extra en casa', 'Estrés antes de cada unidad'].map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-8">
                  <X className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-9" />
                  <span className="text-lg text-gray-700 font-medium" data-id="element-10">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-green-50 p-8 md:p-12 rounded-r-xl border border-green-100 shadow-xl relative z-10 transform md:scale-105" data-id="element-11">
            <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase" data-id="element-12">
              Tu nueva realidad
            </div>
            <h3 className="text-2xl font-bold text-green-700 mb-8 text-center uppercase" data-id="element-13">
              Después del Pack
            </h3>
            <ul className="space-y-6" data-id="element-14">
              {['Clases claras y organizadas', 'Material listo siempre', 'Más seguridad al explicar', 'Menos trabajo fuera del aula', 'Más tranquilidad para enseñar'].map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-15">
                  <div className="bg-green-500 rounded-full p-1" data-id="element-16">
                    <Check className="w-4 h-4 text-white" data-id="element-17" />
                  </div>
                  <span className="text-lg text-gray-800 font-bold" data-id="element-18">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-19">
          <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-xl md:text-2xl font-black py-5 px-10 rounded-lg shadow-[0_5px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase inline-flex items-center justify-center gap-3 no-underline" data-id="element-20">
            🚀 Quiero transformar mis clases ahora
          </a>
        </div>
      </div>
    </section>;
}